import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Truck } from "lucide-react";
import { APEX_LOGO } from "@/lib/brand";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const role = sp.get("role") === "carrier" ? "carrier" : "customer";
  const [f, setF] = useState({ email: "", password: "", name: "", company: "", phone: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    const r = await register({ ...f, role });
    setLoading(false);
    if (r.ok) {
      toast.success("Account created");
      nav(role === "carrier" ? "/portal/carrier" : "/portal/customer");
    } else setErr(r.error);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-md mx-auto">
        <Link to="/" className="inline-block mb-8">
          <img src={APEX_LOGO} alt="Apex Supply Chain Solutions" className="h-14 w-auto object-contain" />
        </Link>
        <div className="font-label text-xs text-[#2E7BC7]">{role === "carrier" ? "Carrier Portal" : "Customer Portal"}</div>
        <h1 className="mt-2 font-display font-black text-3xl text-[#0B3D6E]">Create your account</h1>
        <form onSubmit={submit} className="mt-8 space-y-4 bg-white border border-gray-200 rounded-lg p-8" data-testid="register-form">
          <Field label="Full name" v={f.name} on={upd("name")} required test="reg-name" />
          <Field label="Company" v={f.company} on={upd("company")} test="reg-company" />
          <Field label="Email" type="email" v={f.email} on={upd("email")} required test="reg-email" />
          <Field label="Phone" v={f.phone} on={upd("phone")} test="reg-phone" />
          <Field label="Password" type="password" v={f.password} on={upd("password")} required test="reg-password" />
          {err && <div className="text-sm text-red-600" data-testid="register-error">{err}</div>}
          <button disabled={loading} className="btn-primary-apex w-full" data-testid="register-submit-btn">
            {loading ? "Creating..." : "Create account"}
          </button>
          <div className="text-sm text-slate-600 text-center">Have an account? <Link to={`/login?role=${role}`} className="text-[#2E7BC7] font-semibold">Sign in</Link></div>
        </form>
      </div>
    </div>
  );
}
function Field({ label, v, on, type = "text", required, test }) {
  return (
    <div>
      <label className="text-sm font-semibold text-slate-700 mb-1 block">{label}</label>
      <input type={type} value={v} onChange={on} required={required}
        className="w-full bg-white border border-gray-300 rounded-md px-4 py-2.5 focus:ring-2 focus:ring-[#2E7BC7] focus:border-transparent outline-none"
        data-testid={test} />
    </div>
  );
}
